import { LIGHTBOX_OPEN, LIGHTBOX_CLOSE } from '../common/actionTypes';

/**
 * Action creator that signals lightbox to be opened
 * @param {string} referrer - What is opening the lightbox this will determine what layout the lightbox uses
 * @param {object} payload - The data passed from the referrer
 */
export const openLightbox = (referrer, payload) => ({
  type: LIGHTBOX_OPEN,
  referrer,
  payload,
});

export const closeLightbox = () => ({
  type: LIGHTBOX_CLOSE,
});



// WEBPACK FOOTER //
// ./src/actions/lightboxActions.js